import React from 'react';
import { Wrapper } from './styled';
import SharedTable from 'shared/ui/Table';
import { setCredentialSelected, setOrderByCredentials, showContextMenu, unselectAllCredentials } from 'store/Credentials/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectCredentialsList, selectCredentialsSelected, selectIsFetching } from 'store/Credentials/selectors';
import { selectIsFiltering } from 'store/Filters/selectors';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import NoSearchResults from 'Common/Components/NoSearchResults';

const Table = ({ schema, context, isVulnDetail }) => {
  const dispatch = useDispatch();
  const showContextMenuAction = (value, xPos, yPos) => dispatch(showContextMenu(value, xPos, yPos));
  const data = useSelector(selectCredentialsList);
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const isFetching = useSelector(selectIsFetching);
  const isFiltering = useSelector((state) => selectIsFiltering('credentials', state));
  const unselectAll = () => dispatch(unselectAllCredentials());
  const selectCredential = (credential) => dispatch(setCredentialSelected(credential));

  const isCredentialSelected = (rowInfo) => {
    const rowId = get(rowInfo, 'original.id', '');
    return credentialsSelected.some((e) => e.id === rowId);
  };

  const getTrProps = (rowInfo, showContextMenuAction, isFetching, unselectAll, selectCredential) => {
    const isSelected = isCredentialSelected(rowInfo);
    if (rowInfo && rowInfo.row) {
      return {
        onContextMenu: (e) => {
          e.preventDefault();
          showContextMenuAction(true, e.pageX, e.pageY);
          if (!isSelected && !isFetching) {
            unselectAll();
            selectCredential(rowInfo.original);
          }
        }
      };
    }
    return {};
  };

  const fetchData = (sorted) => !isFetching && dispatch(setOrderByCredentials(sorted, isVulnDetail));

  let noDataText = '';
  if (!isFetching) noDataText = isFiltering ? <NoSearchResults /> : 'No credentials found';

  return (
    <Wrapper>
      <SharedTable
        schema={ schema }
        context={ context }
        data={ data }
        isLoading={ isFetching }
        expanded
        onFetch={ fetchData }
        getRowProps={ (rowInfo) => getTrProps(rowInfo, showContextMenuAction, isFetching, unselectAll, selectCredential) }
        isRowSelected={ isCredentialSelected }
        style={ isVulnDetail && isEmpty(data) ? { height: '95px' } : null }
        noDataText={ noDataText }
      />
    </Wrapper>
  );
};

export default Table;
